module.exports = __webpack_public_path__ + "img/CM-NL-24-Cadillac-Lifestyle.4b019544.jpg";